/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\PasswordConfirm\PasswordConfirm.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Tuesday August 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday, 1st February 2024 12:10:55
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useRef, useState, ReactNode, MouseEvent } from "react";
import Styles from "Content/Password/PasswordConfirm/PasswordConfirm.module.css";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import { useNavigate } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import UserService from "Services/Users/UserService";
import PasswordInput from "../PasswordInput/PasswordInput";
import { useLang } from "Router/LangueProvider";

function PasswordConfirm(props: {token: string, children: ReactNode, renewal?: boolean}) {
    const {translator} = useLang();
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const password = useRef<string | null>(null);

    const HandleSubmit = async (e: any) => {
        e.preventDefault();
        if (props.token && password.current) {
            try {
                const func = props.renewal ? UserService.setPasswordReneval : UserService.setNewPassword;
                const myRet = await (func(password.current, props.token));
                setIsOkay(true);
                setOpenModal(true);
            } catch (error) {
                setOpenModal(false);
                setOpenModal(true);
            }
        }
    };

    const handleToggleModal = (event: MouseEvent<HTMLElement>) => {
        setOpenModal(false);
        if (isOkay)
            navigate(RouterPathResolver.routeLogin.path);
    };

    return (
        <div className={`${Styles.forgotPassword}`}>
            <img loading="lazy" className={`${Styles.backgroundImg}`} src="/assets/parking.png" alt={translator.decode("image.background")} />
            <div className={`${Styles.formHolder}`}>
                <div className={`${Styles.headingForm} mb-3`}>
                    <img loading="lazy" className={`${Styles.logo}`} src="/minimal_logo.png" alt={translator.decode("image.logoAutobuy")} />
                </div>
                {props.children}
                <PasswordInput HandleSubmit={HandleSubmit} ref={password} askCurrentPwd={false} />
            </div>
            <ModalConfirmation show={openModal} onClose={handleToggleModal} closeModal={handleToggleModal} isOkay={isOkay} themeColor={""}/>
        </div>
    )
}

export default PasswordConfirm;
